import {
  ChoiceGroup,
  ComboBox,
  IChoiceGroupOption,
  TextField,
} from "@fluentui/react";
import { FunctionComponent } from "react";
import HelpersIpercBase from "../../../utils/helpers/HelpersIpercBase";
import { TagDefault } from "../../../components/indicadores/Tags";

interface NuevoRegistroProps {
  ActividadId: string;
}

const gridContainerStyles = {
  display: "grid",
  gridTemplateColumns: "repeat(6, 1fr)",
  gridTemplateRows: "repeat(6, 1fr)",
  gridColumnGap: "5px",
  gridRowGap: "5px",
};

const divStyles = {
  div1: { gridArea: "6 / 1 / 7 / 6", padding: "0px 100px 0px 100px" },
  div2: { gridArea: "1 / 6 / 6 / 7" },
  div3: { gridArea: "1 / 1 / 6 / 6", padding: "50px 120px 50px 120px" },
};

const NuevoRegistro: FunctionComponent<NuevoRegistroProps> = () => {
  return (
    <>
      <br />
      <TextField
        {...HelpersIpercBase.TextFieldMultilineProps}
        label="Tarea"
        name="nombre"
        // onChange={_handleTexfildMedidaChange}
      />
      <ComboBox
        label="Peligro"
        options={[]}
        // styles={comboBoxStyles}
        calloutProps={{ doNotLayer: true }}
      />
      <ComboBox
        label="Riesgo"
        options={[]}
        // styles={comboBoxStyles}
        calloutProps={{ doNotLayer: true }}
      />
      <br />
      <TagDefault bodyMenssaje="Evaluacion de Riesgo" />
      <div style={gridContainerStyles}>
        <div style={divStyles.div1}>
          <ChoiceGroup
            name="riesgo"
            defaultSelectedKey="B"
            options={HelpersIpercBase.IPERC_CHOICE_OPTIONS_MATRIZ}
            styles={{ flexContainer: { display: "flex", marginLeft: 50 } }}
          />
        </div>
        <div style={divStyles.div2}>
          <ChoiceGroup
            defaultSelectedKey="B"
            options={[
              { key: "1", text: "1" },
              { key: "2", text: "2" },
              { key: "3", text: "3" },
              { key: "4", text: "4" },
              { key: "5", text: "5" },
            ]}
          />
        </div>
        <div style={divStyles.div3}>
          <TextField
            {...HelpersIpercBase.TextFieldNumberProps1}
            label="Valor de Riesgo"
            id="riesgo"
            name="Valor"
          />
        </div>
        {/* <div style={divStyles.div4}>Div 4</div> */}
      </div>
    </>
  );
};

export default NuevoRegistro;
